/**
 * Where a write lands the writer — docs/08-frontend-and-ux.md §2.2 (`PE --> P`).
 *
 * In bootstrap the row simply exists, so the profile is the answer. Outside it,
 * the endpoints answer `202` and the row stays `pending`: sending the proposer to
 * a profile of a person who is not in the tree yet, with no mention of the
 * question now open about them, is the one navigation that would actively
 * mislead. They go to the proposal instead — or, for a batch, to the list of the
 * proposals they just opened, since §7.3 is explicit that a batch is voted one
 * proposal at a time and the UI must never bundle them.
 */

import type { Proposal } from '@famtree/shared';

export function afterWrite(proposals: Proposal[] | undefined, bootstrapTarget: string): string {
  if (!proposals || proposals.length === 0) return bootstrapTarget;
  if (proposals.length === 1) return `/proposals/${proposals[0]!.id}`;
  return '/proposals?tab=mine';
}
